import {Injectable} from '@angular/core';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {UserProfile} from '../models/user-profile';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class FullProfileService {

  private profileUrl: string = `${ environment.apiRoot }/fullprofile/`;

  constructor(private http: HttpAuth) { }

  public getProfile(userId: string, jobId?: string): Observable<UserProfile> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('user_id', userId);

    if(jobId) {
      params.append('job_id', jobId);
    }

    let options = new RequestOptions({search: params});

    return this.http.get(this.profileUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/full-profile.service.ts